var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "separable" },
    [
      _vm.showModalDeclaracao
        ? _c("gerar-declaracao-tramite", {
            attrs: { numeroProcesso: _vm.numeroProcesso },
            on: {
              closeModal: function() {
                return (this$1.showModalDeclaracao = false)
              }
            }
          })
        : _vm._e(),
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c(
                "el-card",
                {
                  staticClass: "card-info",
                  attrs: { "body-style": { width: "100%" }, shadow: "hover" }
                },
                [
                  _c(
                    "el-row",
                    { staticClass: "cardList", attrs: { span: 24 } },
                    [
                      _c(
                        "el-col",
                        { staticClass: "flex padding", attrs: { span: 18 } },
                        [
                          _c(
                            "div",
                            { staticClass: "cardList" },
                            [
                              _c(
                                "el-col",
                                {
                                  staticClass: "labelDiv",
                                  attrs: { span: 12 }
                                },
                                [
                                  _c("b", [_vm._v("Número do processo:")]),
                                  _vm._v(_vm._s(" " + _vm.numeroProcesso))
                                ]
                              ),
                              _c("el-col", { attrs: { span: 12 } }, [
                                _c("b", [_vm._v("Tipo:")]),
                                _vm._v(_vm._s(" " + this.tipoProcesso))
                              ]),
                              _c("el-col", { attrs: { span: 12 } }, [
                                _c("b", [_vm._v("Status:")]),
                                _vm._v(
                                  _vm._s(
                                    " " +
                                      _vm.statusProcesso(
                                        this.processo && this.processo.status
                                          ? this.processo
                                          : "-"
                                      )
                                  )
                                )
                              ]),
                              _c(
                                "el-col",
                                {
                                  staticClass: "labelDiv",
                                  attrs: { span: 12 }
                                },
                                [
                                  _c("b", [_vm._v("Setor:")]),
                                  _vm._v(
                                    _vm._s(
                                      " " +
                                        this.setorFormatadoProceso(
                                          this.setor,
                                          this.processo.perfil,
                                          this.status
                                        )
                                    )
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _c("el-col", { attrs: { span: 6 } }, [
                        _c(
                          "div",
                          { staticClass: "flexEndButton" },
                          [
                            _vm.isDeclaracaoVisible
                              ? _c(
                                  "el-button",
                                  {
                                    staticClass: "green textButtonBreak",
                                    attrs: { tipo: "success" },
                                    on: {
                                      click: function($event) {
                                        return _vm.goTo()
                                      }
                                    }
                                  },
                                  [
                                    _c("span", { staticClass: "center" }, [
                                      _c("i", {
                                        staticClass: "fal fa-file-download"
                                      }),
                                      _vm._v(
                                        "  Declaração de trâmite processual"
                                      )
                                    ])
                                  ]
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1bda3dcd", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1bda3dcd","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/central/processos/CabecalhoProcesso.vue
// module id = null
// module chunks = 